/**
 * Module Name Injection Token
 *
 * Injection token for identifying which Module Federation application is currently running. Used to determine whether
 * impersonation should be applied based on MODULE_CONFIG.
 *
 * Each app MUST provide this token in their app.config.ts:
 *
 * @example
 *   ```typescript
 *   // web.assessment/src/app/app.config.ts
 *   import { MODULE_NAME } from '@complexcare/conductor';
 *
 *   export const appConfig: ApplicationConfig = {
 *     providers: [
 *       { provide: MODULE_NAME, useValue: 'web.assessment' },
 *       // ...other providers
 *     ]
 *   };
 *   ```;
 *
 * @packageDocumentation
 */

import { InjectionToken } from '@angular/core';

/**
 * Injection token for the current module name
 *
 * Valid values: 'web.assessment', 'web.admin', 'web.shell', 'web.template', 'web.audit'
 *
 * This token is used by AuthorizationService to determine whether to apply impersonation state when computing
 * permissions.
 */
export const MODULE_NAME = new InjectionToken<string>('MODULE_NAME', {
  providedIn: 'root',
  factory: () => {
    // Default to unknown module - impersonation will not apply
    // Apps should explicitly provide this token in their app.config
    return 'unknown';
  },
});
